export const ATTACHMENTS_BUCKET =
  import.meta.env.VITE_ATTACHMENTS_BUCKET || "attachments";

// Public bucket for company logos, settings logos and seller photos (Block 2A, migration M2b)
export const BRANDING_BUCKET = "branding";

// Lifetime of the signed URLs shown on screen (Block 2A: the bucket is private)
export const SIGNED_URL_TTL_SECONDS = 3600;

const PUBLIC_URL_MARKER = `/storage/v1/object/public/${ATTACHMENTS_BUCKET}/`;

/**
 * Storage path of a saved attachment: its `path`, or, for records saved before signed URLs (Block 2A), the part
 * of its old public URL after "/storage/v1/object/public/<bucket>/". Null when it is not a file of the bucket
 * (blob:/data: previews, external links, FakeRest).
 */
export const getAttachmentPath = (attachment: {
  path?: string | null;
  src?: string | null;
}): string | null => {
  if (attachment.path) return attachment.path;
  const src = attachment.src ?? "";
  const index = src.indexOf(PUBLIC_URL_MARKER);
  if (index < 0) return null;
  const path = src.slice(index + PUBLIC_URL_MARKER.length).split(/[?#]/)[0];
  try {
    return decodeURIComponent(path) || null;
  } catch {
    return path || null;
  }
};
